// frontend/src/services/quiz.service.ts

import { authService } from './auth.service';
import { ActiveQuiz, QuizDifficulty, QuizResult, QuizStats } from '../types/quiz.types';

const API_BASE = (import.meta.env.PROD && (import.meta.env.VITE_API_BASE_URL === 'http://localhost:8080' || !import.meta.env.VITE_API_BASE_URL)) ? '' : (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080');

class QuizApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'QuizApiError';
  }
}

async function authedFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const token = await authService.getAccessToken();
  if (!token) throw new QuizApiError('Oturum bulunamadı, lütfen giriş yapın.');

  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(init?.headers ?? {}),
    },
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new QuizApiError(data?.error?.message || `İstek başarısız (HTTP ${res.status})`);
  }
  return data as T;
}

export const quizService = {
  async generateQuiz(params: {
    topic: string;
    difficulty: QuizDifficulty;
    questionCount?: number;
    courseId?: string;
  }): Promise<ActiveQuiz> {
    return authedFetch<ActiveQuiz>('/api/quizzes/generate', {
      method: 'POST',
      body: JSON.stringify(params),
    });
  },

  async submitQuiz(quizId: string, answers: Record<string, string>): Promise<QuizResult> {
    return authedFetch<QuizResult>('/api/quizzes/submit', {
      method: 'POST',
      body: JSON.stringify({ quizId, answers }),
    });
  },

  async getStats(): Promise<QuizStats> {
    return authedFetch<QuizStats>('/api/quizzes/stats');
  },
};

export { QuizApiError };
